<template>
  <div>
    <div class="row">
      <div class="col-lg-6 pr-0 alpha">
        <b-form-group class="col-12 col-lg-12 col-sm-6 col-md-4"
          label="Titulo*"
          label-for="title">
          <b-form-input id="name"
            type="text"
            :value="seo.title"
            :required="true"
            :maxlength="70"
            @input="updateSeo('title', arguments[0])"
            @change="hasTitle = true"
            placeholder="Título"></b-form-input>
            <span class="text-muted caracteres-counter float-right">{{ seo.title.length }}/70 caracteres</span>
            <div class="mt-2">
              <b-form-checkbox
                v-model="useNameInSeoTitleValue"
                @change="useNameInSeoTitle"
                :value="true"
                :unchecked-value="false">
                Utilizar <b>título</b> como SEO
              </b-form-checkbox>
           </div>
        </b-form-group>
      </div>
      <div class="col-lg-6 pl-0 pr-0">
        <b-form-group class="col-12 col-lg-12 col-sm-6 col-md-8"
          label="Descrição*"
          label-for="description">
          <b-form-input id="name"
            type="text"
            :value="seo.description"
            :required="true"
            :maxlength="160"
            @input="updateSeo('description', arguments[0])"
            placeholder="Descrição"></b-form-input>
          <span class="text-muted caracteres-counter float-right">{{ seo.description.length }}/160 caracteres</span>
        </b-form-group>
      </div>
      <b-form-group class="col-12 col-lg-12 col-sm-6 col-md-4 mt-3" label="Preview" label-for="preview">
        <div class="gg-card">
          <h3 class="gg-title">{{ seo.title || 'Título' }}</h3>
          <cite class="gg-url">{{ "https://www.rodonavesseminovos.com.br" }}</cite>
          <span class="gg-desc">{{ seo.description || "Descrição da página" }}</span>
        </div>
      </b-form-group>
    </div>
    <div class="row" v-if="manageFriendlyUrl">
      <div class="col-12">
        <b-alert show>
          A URL amigavel deve facilitar o acesso ao conteúdo. Ela deve ser única para cada tipo de conteúdo.
          <br>
          Desta forma, para criar uma nova URL utilize o mecanismo para verificar a existência.
        </b-alert>
      </div>

      <b-form-group class="col-12"
        label="Nova URL"
        label-for="url"
        description="Não utilize caracteres especiais">

        <b-input-group>
          <b-form-input id="url"
            type="text"
            :value="friendlyUrl"
            @input="updateUrl(arguments[0])"
            :formatter="slugify"
            lazy-formatter
            placeholder=""></b-form-input>

          <b-input-group-append>
            <b-btn
            variant="outline-success"
            @click.stop.prevent="checkUrl">Checar</b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <div class="col-12" v-show="showUrls">
        <h4>
          URLs cadastradas
        </h4>

        <b-list-group class="mb-1">
          <b-list-group-item
            :key="`url.url-${index}`"
            v-for="(url, index) in urls"
            class="d-flex justify-content-between align-items-center">

            {{ url.url }}

            <b-badge v-if="index === 0" variant="primary" pill>
              PRINCIPAL
            </b-badge>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
  </div>
</template>
<script>
  import { get, set, clone } from 'lodash'
  import slugify from 'slugify'
  import Form from '@/services/form'
  import http from '@/services/api/seo-friendly-urls'

  export default {
    props: {
      slugable: {
        type: String,
        default: ''
      },

      showUrls: {
        type: Boolean,
        default: false
      },

      form: {
        type: [Object],
        required: true
      },

      pageName: {
        type: String,
        default: ''
      },

      urls: {
        type: Array,
        default () { return [] }
      },

      manageFriendlyUrl: {
        type: Boolean,
        default: false
      },

      name: {
        type: String
      }
    },

    data () {
      return {
        empty: {
          title: '',
          description: ''
        },
        seo: {
          title: '',
          description: ''
        },
        hasTitle: false,
        newUrl: '',
        urlForm: new Form({
          url: ''
        }),
        useNameInSeoTitleValue: true
      }
    },

    watch: {
      slugable (newSlugable) {
        if (!this.form.frindly_url) {
          this.newUrl = this.slugify(newSlugable)
        }
      },

      name: {
        handler (value) {
          if (!this.hasTitle) {
            this.updateSeo('title', value)
          }
        },
        deep: true
      }
    },

    created () {
      this.seo = this.form.seo || this.empty
      this.hasTitle = this.seo.title
      this.useNameInSeoTitleValue = !this.form.id
    },

    computed: {
      friendlyUrl () {
        return this.newUrl || get(this.form, 'friendly_url', '')
      }
    },

    methods: {
      slugify,

      useNameInSeoTitle (checked) {
        if (checked) {
          this.updateSeo('title', this.name)
          this.hasTitle = false
        } else {
          this.hasTitle = true
        }
      },

      updateSeo (field, value) {
        let seo = clone(this.seo)

        set(seo, field, value)

        this.form.seo = seo
        this.seo = seo
      },

      updateUrl (value) {
        this.newUrl = value.toLowerCase()

        if (!this.form.friendlyUrls) {
          this.form.initial.friendlyUrls = []
          this.form.friendlyUrls = []
        }

        this.form.friendlyUrls[0] = { url: value.toLowerCase() }
      },

      checkUrl () {
        const self = this

        http.check(self.form.id || null, self.friendlyUrl).then(function (res) {
          self.$toasted.success('Url checada. Não esqueça de salvar!')
          self.newUrl = res.data.url || self.friendlyUrl
        })
      }
    }
  }
</script>

<style media="screen" scoped lang="scss">
  textarea.form-control {
    height: 60px !important;
  }
  .gg-card {
    padding: 10px 15px;
    min-height: 120px;
    -webkit-box-shadow: 0 4px 10px rgba(175, 175, 175, 0.3);
    box-shadow: 0 4px 10px rgba(175, 175, 175, 0.3);
    width: 100%;
    display: flex;
    flex-direction: column;

    .gg-title {
      color: #1a0dab;
      font-family: 'Arial', sans-serif;
      font-size: 18px;
      line-height: 24px;
      font-weight: 400;
      margin: 0px;
      margin-bottom: 5px;
    }
    .gg-url {
      color: #006621;
      display: block;
      font-family: 'Arial', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      margin-bottom: 5px;
    }
    .gg-desc {
      font-family: 'Arial', sans-serif;
      font-size: 13px;
      display: block;
      line-height: 20px;
      color: #545454;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/forms/System/SeoFields.vue